/* 후기 띠 — 자동 흐름 + 수동 조작.

   예전에는 CSS transform 애니메이션(트랙 두 벌 + translateX(0→-100%))이었다.
   그 방식은 위치를 JS 가 모르기 때문에 앞뒤 이동도, 선택도, 드래그도 붙일 수가 없다.

   그래서 네이티브 가로 스크롤로 바꿨다. 자동 흐름·휠·터치 스와이프·드래그·버튼·점이
   전부 scrollLeft 하나를 움직이므로 서로 싸우지 않는다.

   끊김 없는 순환은 카드를 여러 벌 깔아두고, 한 벌 폭(loopWidth)을 넘어가면
   scrollLeft 에서 그만큼 빼는 방식으로 만든다. 눈에는 이어져 보인다. */
(function () {
  /* 2026-10-28 속도: 띠가 화면 근처(600px)에 올 때까지 시작하지 않는다.
     예전에는 페이지를 열자마자 카드를 여러 벌 복제했고, 복제본의 후기 사진(약 4MB)과
     계산이 첫 화면을 붙잡았다(라이트하우스 모바일 기준 이 스크립트만 8.8초). */
  function init() {
    var views = document.querySelectorAll('.mo-rev__viewport:not([data-mo-rev-done]):not([data-mo-rev-wait])');
    for (var i = 0; i < views.length; i++) watch(views[i]);
  }

  function watch(view) {
    if (!('IntersectionObserver' in window)) { setup(view); return; }
    view.setAttribute('data-mo-rev-wait', '');
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        io.disconnect();
        view.removeAttribute('data-mo-rev-wait');
        setup(view);
        return;
      }
    }, { rootMargin: '600px 0px' });
    io.observe(view);
  }

  function setup(view) {
    if (view.hasAttribute('data-mo-rev-done')) return;
    var track = view.querySelector('.mo-rev__track');
    if (!track || !track.children.length) return;
    view.setAttribute('data-mo-rev-done', '');

    var root = view.parentNode;
    var controls = root.querySelector('[data-mo-rev-controls]');
    var dotsBox = root.querySelector('[data-mo-rev-dots]');
    var prevBtn = root.querySelector('[data-mo-rev-prev]');
    var nextBtn = root.querySelector('[data-mo-rev-next]');

    var speed = parseFloat(view.getAttribute('data-speed')) || 26;
    var autoplay = view.getAttribute('data-autoplay') === '1';
    var sid = view.getAttribute('data-sid');
    var live = view.getAttribute('data-live') === '1';
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // 원본 카드를 보관한다. 다시 깔 때마다 여기서 새로 찍어낸다.
    var seed = [];
    for (var a = 0; a < track.children.length; a++) seed.push(track.children[a].cloneNode(true));
    var sig = signature(seed);

    var loopWidth = 0;   // 카드 한 벌의 폭. 이만큼 넘어가면 scrollLeft 를 되돌린다.
    var stride = 0;      // 카드 한 장 + 간격
    var holdUntil = 0;   // 이 시각까지는 자동 흐름을 멈춘다
    var dragging = false;
    var lockWrap = false;
    var anim = null;     // 버튼·점으로 옮기는 중인 애니메이션
    var animTo = 0;      // 그 애니메이션의 도착 위치
    var resizeTimer = null;

    function signature(cards) {
      var out = [];
      for (var i = 0; i < cards.length; i++) out.push(cards[i].getAttribute('data-rid') || '');
      return out.join(',');
    }

    function gap() {
      var cs = getComputedStyle(track);
      var g = parseFloat(cs.columnGap || cs.gap);
      return isNaN(g) ? 0 : g;
    }

    function layout() {
      cancelGlide();
      track.textContent = '';
      for (var i = 0; i < seed.length; i++) track.appendChild(seed[i].cloneNode(true));

      stride = track.children.length ? (track.children[0].getBoundingClientRect().width + gap()) : 0;
      var one = track.getBoundingClientRect().width + gap();

      /* 한 벌이 화면보다 좁으면 빈 구간이 보인다. 화면보다 넓어질 때까지 벌을 늘린다.
         loopWidth 는 '늘린 한 벌'의 폭이고, 그 위에 똑같은 벌을 한 번 더 깔아
         오른쪽 끝에서도 다음 카드가 이어져 보이게 한다. */
      var guard = 0;
      while (one < view.clientWidth + 400 && guard < 12) {
        for (var j = 0; j < seed.length; j++) track.appendChild(seed[j].cloneNode(true));
        guard++;
        one = track.getBoundingClientRect().width + gap();
      }
      loopWidth = one;

      var copies = track.children.length;
      for (var k = 0; k < copies; k++) {
        var c = track.children[k].cloneNode(true);
        c.setAttribute('aria-hidden', 'true');   // 같은 글을 두 번 읽히지 않는다
        // 숨긴 사본 안의 영상 링크에 Tab 이 멈추지 않게 한다
        var links = c.querySelectorAll('a, button');
        for (var q = 0; q < links.length; q++) links[q].setAttribute('tabindex', '-1');
        track.appendChild(c);
      }

      buildDots();
      if (controls) controls.hidden = false;
      normalize();
      sync();
    }

    function buildDots() {
      if (!dotsBox) return;
      dotsBox.textContent = '';
      for (var i = 0; i < seed.length; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mo-rev__dot';
        b.setAttribute('data-i', String(i));
        b.setAttribute('aria-label', 'Review ' + (i + 1) + ' of ' + seed.length);
        dotsBox.appendChild(b);
      }
    }

    // 지금 맨 왼쪽에 보이는 카드가 원본 몇 번째인지
    function activeIndex() {
      if (!stride || !loopWidth) return 0;
      var pos = ((view.scrollLeft % loopWidth) + loopWidth) % loopWidth;
      return Math.round(pos / stride) % seed.length;
    }

    function sync() {
      if (!dotsBox) return;
      var cur = activeIndex();
      var dots = dotsBox.children;
      for (var i = 0; i < dots.length; i++) {
        dots[i].setAttribute('aria-current', i === cur ? 'true' : 'false');
      }
    }

    /* scrollLeft 가 한 벌 폭을 넘어가면 그만큼 빼서 제자리로 돌린다.
       버튼·점으로 옮기는 중에는 건드리지 않는다(목표 위치가 어긋난다). */
    function normalize() {
      if (lockWrap || !loopWidth) return;
      if (view.scrollLeft >= loopWidth) view.scrollLeft -= loopWidth;
      else if (view.scrollLeft < 0) view.scrollLeft += loopWidth;
    }

    function hold(ms) { holdUntil = Date.now() + (ms || 2500); }

    // 한 번에 몇 장 넘길지. 화면에 보이는 장수만큼 넘기면 읽던 자리를 잃지 않는다.
    function pageCards() {
      if (!stride) return 1;
      return Math.max(1, Math.floor(view.clientWidth / stride));
    }

    /* 옮기던 애니메이션을 멈춘다. lockWrap 도 반드시 같이 푼다.
       안 풀면 자동 흐름이 영영 멈춘다. */
    function cancelGlide() {
      if (anim) { cancelAnimationFrame(anim); anim = null; }
      lockWrap = false;
    }

    /* 목표 위치까지 프레임을 직접 그려서 옮긴다.
       scrollTo({ behavior: 'smooth' }) 를 쓰지 않는 이유:
       - 도착 위치를 우리가 쥐고 있어야 연타를 목적지 기준으로 이어 셀 수 있다(jump 참고).
       - 브라우저마다 속도·중단 방식이 다르고, 도중에 끝났는지 알 방법이 없어
         예전에는 620ms 타이머로 끝났다고 '짐작'했다. 직접 그리면 끝나는 순간을 안다. */
    function glideTo(to) {
      if (!loopWidth) return;
      hold(4000);
      cancelGlide();

      // 목표가 범위를 벗어나면 출발점과 목표를 같이 한 벌만큼 옮겨 두고 움직인다
      if (to < 0) { view.scrollLeft += loopWidth; to += loopWidth; }
      else if (to > loopWidth * 1.5) { view.scrollLeft -= loopWidth; to -= loopWidth; }

      var from = view.scrollLeft;
      if (Math.abs(to - from) < 1) { normalize(); sync(); return; }
      animTo = to;

      if (calm) { view.scrollLeft = to; normalize(); sync(); return; }

      lockWrap = true;
      var t0 = 0;
      anim = requestAnimationFrame(function step(t) {
        if (!t0) t0 = t;
        var p = Math.min(1, (t - t0) / 460);
        var e = 1 - Math.pow(1 - p, 3);          // ease-out
        view.scrollLeft = from + (to - from) * e;
        if (p < 1) { anim = requestAnimationFrame(step); return; }
        anim = null;
        lockWrap = false;
        normalize();
        sync();
      });
    }

    /* 버튼·키보드로 n 장 넘기기.
       ⚠ 옮기는 중에 또 누르면 지금 위치가 아니라 '가던 목적지'에서 이어서 센다.
          지금 위치에서 세면 연타할 때 카드가 칸에 안 맞고 어중간하게 걸친다
          (1440px 실측: 4연타 후 4.73장 위치에 멈췄다).
          자동 흐름이 칸 사이에 세워 둔 위치에서 눌러도 카드 경계에 맞춰 선다. */
    function jump(n) {
      if (!stride) return;
      var from = anim ? animTo : view.scrollLeft;
      var slot = n > 0 ? Math.floor(from / stride + 0.02) : Math.ceil(from / stride - 0.02);
      glideTo((slot + n) * stride);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { jump(-pageCards()); });
    if (nextBtn) nextBtn.addEventListener('click', function () { jump(pageCards()); });

    if (dotsBox) {
      dotsBox.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('.mo-rev__dot') : null;
        if (!b || !loopWidth) return;
        var want = parseInt(b.getAttribute('data-i'), 10) || 0;
        var pos = ((view.scrollLeft % loopWidth) + loopWidth) % loopWidth;
        glideTo(view.scrollLeft - pos + want * stride);
      });
    }

    // 키보드로도 넘긴다
    view.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); jump(pageCards()); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); jump(-pageCards()); }
    });

    /* 마우스로 끌어서 움직이기.
       포인터 이벤트 하나로 마우스·터치·펜을 같이 받는다. 터치는 브라우저 기본
       스와이프가 이미 되므로 마우스일 때만 가로챈다.
       ⚠ 누르자마자 포인터를 잡으면(setPointerCapture) click 이 카드가 아니라 띠 전체로 가서
          영상 카드를 눌러도 팝업이 안 열린다. 5px 넘게 움직였을 때만 끌기로 본다. */
    var startX = 0, startLeft = 0, pressed = false, dragMoved = false;
    view.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch' || e.button !== 0) return;
      cancelGlide();
      pressed = true;
      dragMoved = false;
      startX = e.clientX;
      startLeft = view.scrollLeft;
    });
    view.addEventListener('pointermove', function (e) {
      if (!pressed) return;
      // 띠 밖에서 버튼을 놓으면 pointerup 이 안 온다. 버튼이 풀렸으면 누름 상태를 버린다.
      if (!(e.buttons & 1)) { pressed = false; return; }
      var dx = e.clientX - startX;
      if (!dragging) {
        if (Math.abs(dx) < 5) return;
        dragging = true;
        dragMoved = true;
        view.classList.add('is-drag');
        try { view.setPointerCapture(e.pointerId); } catch (err) {}
        hold(3000);
      }
      var next = startLeft - dx;
      /* 끄는 중에 한 벌 경계를 넘으면 기준점도 같이 옮긴다.
         scrollLeft 만 되돌리면 다음 move 에서 startLeft - dx 가 그걸 다시 덮어쓴다. */
      if (loopWidth) {
        if (next >= loopWidth) { startLeft -= loopWidth; next -= loopWidth; }
        else if (next < 0) { startLeft += loopWidth; next += loopWidth; }
      }
      view.scrollLeft = next;
      if (Math.abs(dx) > 3) e.preventDefault();
      sync();
    });
    function endDrag(e) {
      pressed = false;
      if (!dragging) return;
      dragging = false;
      // 끌고 놓은 직후의 click 한 번만 막는다. 오래 남겨 두면 다음 Enter 키까지 먹는다.
      setTimeout(function () { dragMoved = false; }, 60);
      view.classList.remove('is-drag');
      try { view.releasePointerCapture(e.pointerId); } catch (err) {}
      normalize();
      sync();
      hold(2500);
    }
    view.addEventListener('pointerup', endDrag);
    view.addEventListener('pointercancel', endDrag);
    view.addEventListener('dragstart', function (e) { e.preventDefault(); });

    /* 영상 후기 → Loox 공식 팝업에서 재생.
       Loox 가 없는 페이지면 링크 기본 동작(후기 페이지)으로 둔다. */
    view.addEventListener('click', function (e) {
      if (dragMoved) { dragMoved = false; e.preventDefault(); e.stopPropagation(); return; }
      var a = e.target.closest ? e.target.closest('[data-mo-rev-video]') : null;
      if (!a) return;
      var L = window.LOOX;
      if (!L || typeof L.openQV !== 'function') return;
      e.preventDefault();
      hold(3000);
      try { L.openQV(a.getAttribute('data-mo-rev-video')); }
      catch (err) { location.href = a.href; }
    }, true);

    // 휠·터치 스와이프는 네이티브 스크롤이 처리한다. 손이 닿으면 옮기던 것과 자동 흐름을 멈춘다.
    view.addEventListener('scroll', function () { if (!dragging) sync(); }, { passive: true });
    view.addEventListener('wheel', function () { cancelGlide(); hold(2500); }, { passive: true });
    view.addEventListener('touchstart', function () { cancelGlide(); hold(4000); }, { passive: true });

    // 읽으려고 멈춰 선 사람을 방해하지 않는다
    view.addEventListener('pointerenter', function (e) { if (e.pointerType !== 'touch') hold(99999); });
    view.addEventListener('pointerleave', function (e) { if (e.pointerType !== 'touch') holdUntil = Date.now() + 400; });
    view.addEventListener('focusin', function () { hold(99999); });
    view.addEventListener('focusout', function () { holdUntil = Date.now() + 400; });

    layout();

    // 카드 폭이 25vw 라 창 크기가 바뀌면 한 벌 폭도 바뀐다. 다시 깔아야 빈칸이 안 생긴다.
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(layout, 220);
    }, { passive: true });

    /* 자동 흐름. CSS 애니메이션이 아니라 매 프레임 scrollLeft 를 밀어 준다.
       그래야 손으로 만진 위치에서 끊기지 않고 이어서 흐른다.
       scrollLeft 는 정수로 반올림될 수 있어서 소수 이동분을 따로 모았다가 민다. */
    if (autoplay && !calm) {
      var last = 0, carry = 0;
      requestAnimationFrame(function step(t) {
        requestAnimationFrame(step);
        if (!last) { last = t; return; }
        var dt = t - last;
        last = t;
        if (dt > 100) return;                 // 탭을 비웠다 돌아온 프레임은 건너뛴다
        if (dragging || lockWrap) return;
        if (Date.now() < holdUntil) return;
        if (document.hidden) return;
        /* Loox 팝업(영상)이 열려 있는 동안 뒤에서 흐르지 않는다.
           ⚠ body 의 loox-overlay-is-active 클래스로 보면 안 된다. openQV 로 연 팝업에는
              그 클래스가 붙지 않았다(실측). 팝업 요소 자체(.loox-overlay)가 있는지로 본다. */
        if (document.querySelector('.loox-overlay')) return;
        carry += speed * dt / 1000;
        var px = Math.floor(carry);
        if (px < 1) return;
        carry -= px;
        view.scrollLeft += px;
        normalize();
      });
    }

    /* ── 실시간 갱신 ──────────────────────────────────────────────
       후기는 서버에서 이미 그려져 나온다. 다만 홈 HTML 이 CDN 에 캐시될 수 있어서,
       화면을 그린 뒤 섹션 렌더링 API 로 이 섹션만 다시 받아 비교한다.
       후기 id 목록이 같으면 아무것도 하지 않는다(자동 흐름이 튀지 않게).

       ⚠ 편집기(design mode)에서는 이 API 가 동작하지 않아 끈다.
       ⚠ 실패해도 조용히 넘어간다. 서버가 그려준 후기가 이미 화면에 있다. */
    if (!live || typeof fetch !== 'function') return;

    var lastFetch = 0;

    function refresh() {
      var now = Date.now();
      if (now - lastFetch < 60000) return;
      lastFetch = now;

      var url;
      try {
        url = new URL(location.pathname, location.origin);
        var pv = new URLSearchParams(location.search).get('preview_theme_id');
        if (pv) url.searchParams.set('preview_theme_id', pv);
        url.searchParams.set('sections', sid);
        url.searchParams.set('_', String(now));
      } catch (e) { return; }

      fetch(url.toString(), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j || !j[sid]) return;
          var doc = new DOMParser().parseFromString(j[sid], 'text/html');
          var fresh = doc.querySelector('.mo-rev__track');
          if (!fresh || !fresh.children.length) return;

          var cards = [];
          for (var i = 0; i < fresh.children.length; i++) {
            if (!fresh.children[i].hasAttribute('aria-hidden')) cards.push(fresh.children[i]);
          }
          if (!cards.length || signature(cards) === sig) return;

          seed = cards;
          sig = signature(cards);
          layout();
        })
        .catch(function () {});
    }

    setTimeout(refresh, 1200);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) refresh();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // 테마 편집기에서 섹션을 다시 그릴 때도 붙인다
  document.addEventListener('shopify:section:load', init);
})();
